import Reveal from "@/components/landing/Reveal";
import { renderTitle } from "@/components/landing/utils";

export default function ExpansionNoteSection({ block }) {
  const title = block?.title || "Nuestra expansión está <em>evolucionando</em>.";
  const body = block?.body || "Después de desarrollar nuestra presencia mediante sucursales y franquicias, Rubí abre una nueva etapa de crecimiento mediante proyectos de participación para nuevas aperturas seleccionadas.";
  return (
    <section id="evolucion" className="bg-[#0A0A0A] on-onyx py-16 md:py-20" data-testid="expansion-note-section">
      <div className="max-w-[1300px] mx-auto px-5 sm:px-6 lg:px-10 grid md:grid-cols-[0.9fr_1.1fr] gap-6 md:gap-14 items-start">
        <Reveal>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl text-white leading-[1.05]">{renderTitle(title)}</h2>
        </Reveal>
        <Reveal delay={140}>
          <p className="text-[#A1A1AA] text-base md:text-lg leading-relaxed md:pt-2 border-l border-[#FFBF57]/60 pl-5">{body}</p>
        </Reveal>
      </div>
    </section>
  );
}
